import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const RegioneContext = React.createContext(null);

const { Provider } = RegioneContext;

export const RegioneProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        regione: null,
    });

    const [isLoadingRegione, setIsLoadingRegione] = useState(false);
    const getRegioneAsync = async (regioneId) => {
        try {
            setIsLoadingRegione(true);
            const r = await fetchAuthorized(ApiRoutes.Regione.GetRegione({ regioneId }), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            setState({ regione: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingRegione(false);
        }
    }

    const [isUpdatingRegione, setIsUpdatingRegione] = useState(false);
    const updateRegioneAsync = async (regioneId, regione) => {
        try {
            setIsUpdatingRegione(true);
            const r = await fetchAuthorized(ApiRoutes.Regione.UpdateRegione({ regioneId }), {
                method: HttpMethods.POST,
                body: JSON.stringify(regione),
            });
            const result = await r.json();
            setState({
                regione: {
                    ...result,
                    inizioValidita: new Date(result.inizioValidita),
                    fineValidita: result.fineValidita ? new Date(result.fineValidita) : null
                }
            });
            showSuccessMessage("Regione aggiornata");
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingRegione(false);
        }
    }

    const [isAddingRegione, setIsAddingRegione] = useState(false);
    const addRegioneAsync = async (regione) => {
        try {
            setIsAddingRegione(true);
            const r = await fetchAuthorized(ApiRoutes.Regione.AddRegione(), {
                method: HttpMethods.PUT,
                body: JSON.stringify(regione),
            });
            const result = await r.json();
            setState({
                regione: {
                    ...result,
                    inizioValidita: new Date(result.inizioValidita),
                    fineValidita: result.fineValidita ? new Date(result.fineValidita) : null
                }
            });
            showSuccessMessage("Regione creata");
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsAddingRegione(false);
        }
    }

    return (
        <Provider value={{
            state,
            setState,

            isLoadingRegione,
            getRegioneAsync,

            isUpdatingRegione,
            updateRegioneAsync,

            isAddingRegione,
            addRegioneAsync,
        }}>
            {props.children}
        </Provider>
    );
}